import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useGetSalesComparison } from '../hooks/get-sales-comparison.hook';
import { useFindOrders } from '../../orders/hooks/get-orders.hook';
import SalesPerformanceChart from '../components/Charts/SalesPerformanceChart.component';
import LastOrdersTimeline from '../components/Timelines/LastOrdersTimeline.component';

const LAST_ORDERS_COUNT = 8;

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.7rem',

    '& > h2': {
      margin: 0,
    },
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },
});

export default function AdminStatisticsOverviewView() {
  const classes = useStyles();

  const { isLoading: isLoadingSales, salesComparison } = useGetSalesComparison();
  const { loading: isLoadingOrders, orders } = useFindOrders({
    page: 1,
    limit: LAST_ORDERS_COUNT,
    sortDirection: 'desc',
    filters: {},
  });

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid className={classes.block} item xs={12} md={9}>
          <h4>Performance de la semaine</h4>
          <SalesPerformanceChart isLoading={isLoadingSales} salesComparison={salesComparison} />
        </Grid>
        <Grid className={classes.block} item xs={12} md={3}>
          <h4>Dernières commandes</h4>
          <LastOrdersTimeline isLoading={isLoadingOrders} orders={orders} />
        </Grid>
      </Grid>
    </div>
  );
}
